<template>
	<div class="ui ui--bildnachweise">
		<nav class="bildnachweise--navigation">
			<button class="btn-close-black bildnachweise--close" @click="close()">&#x2715;</button>
		</nav>
		<div class="bildnachweise--content">
			<div>
				<ul class="bildnachweise--list">
					<li class="bildnachweise--list--element" v-for="data in bildnachweiseData" :key="data.source">
						<figure class="bildnachweise--figure">
							<img :src="data.imageUrl" alt="" />
						</figure>
						<div class="bildnachweise--text">
							<h2 class="bildnachweise--headline">
								<p>{{ data.attribution }}</p>
							</h2>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		bildnachweiseData: Array,
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
.ui--bildnachweise {
	display: flex;
	position: fixed;
	z-index: 100;
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
	background-color: rgb(255 255 255 / 0.5);
	backdrop-filter: blur(16px);
}
.bildnachweise--navigation {
	position: absolute;
	top: 2rem;
	right: 3.5rem;
	z-index: 20;
	display: flex;
	justify-content: flex-end;
}
.bildnachweise--close {
	font-size: 5rem !important;
	height: 8rem;
	width: 8rem;
	background-color: rgb(255 255 255 / 1);
	box-shadow: none;
	border-radius: 9999px;
	border-width: 1px;
	background-repeat: no-repeat;
}
.bildnachweise--content {
	position: relative;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	height: 100%;
	background-color: rgb(255 255 255 / 1);
	padding-bottom: 10rem;
	overflow-x: hidden;
	overflow-y: scroll;
	touch-action: pan-y;
	-webkit-overflow-scrolling: touch;
}
.bildnachweise--list {
	display: grid;
	grid-template-columns: repeat(4, 400px);
	height: 100vh;
	width: 100vw;
	padding-top: 14rem;
	padding-bottom: 1rem;
	justify-content: center;
	gap: 3rem;
}
.bildnachweise--list--element {
	background-color: rgb(226 232 240 / 1);
	position: relative;
	border-radius: 1rem;
	box-shadow: 0 0 2em 0 rgb(226 232 240);
	flex: 0 0 32%;
}
.bildnachweise--figure {
	position: relative;
	width: 100%;
	aspect-ratio: 3 / 2;
}
.bildnachweise--text {
	font-family: Bold, sans-serif;
	font-size: 1.875rem;
	line-height: 2.25rem;
	font-weight: 700;
	left: 0px;
	right: 0px;
	display: flex;
	align-items: center;
	text-align: center;
}
.bildnachweise--headline {
	width: 100%;
	padding: 0.5em;
	background-color: rgb(255 255 255 / 1);
	height: 70px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: Helvetica, Arial, sans-serif !important;
	line-height: 1.75rem;
	font-size: 1.25rem !important;
}
</style>
